import React, { useState, useRef } from 'react';
import { connect } from 'react-redux';
import { Formik, Form, Field, FieldArray, ErrorMessage } from 'formik';
import { Form as bootStrapForm, InputGroup, Col, Button, FormControl, Spinner } from 'react-bootstrap';
import CyberSecurity from '../../apis/cyberSecurityData';
import { jobRoleOptions, companySizeOptions, getIndustryOptions, countryOptions, jobSeniorityOptions, statesOptions } from '../../configs/dropdownOptions';
import * as yup from 'yup';

const schema = yup.object({
    firstName: yup.string().matches(/^[ A-Za-z0-9_.&',-\/()]*$/, 'No special charachters').max(50).required('This is a required field'),
    lastName: yup.string().matches(/^[ A-Za-z0-9_.&',-\/()]*$/, 'No special charachters').max(50).required('This is a required field'),
    companyName: yup.string().matches(/^[ A-Za-z0-9_.&',-\/()]*$/, 'No special charachters').max(50).required('This is a required field'),
    email: yup.string().max(50).matches(/^[ A-Za-z0-9_.@&',-\/()]*$/, 'Please enter a valid Email Address').email('Please enter a valid Email Address').required('This is a required field'),
    password: yup.string().min(8).max(50).required('This is a required field'),
    rePassword: yup.string().min(8).max(20).required('This is a required field'),
});

function PrivateBetaForm(props) {
    const [updated, setUpdated] = useState(false);
    const [submitting, setSubmitting] = useState(false);

    const renderTextField = ({ field, form, meta, checkHidden }, label) => {
        return (
            <bootStrapForm.Group>
                <bootStrapForm.Label>{label}</bootStrapForm.Label>
                <bootStrapForm.Control isInvalid={meta.touched && meta.error} {...field} type="text" placeholder={label} autoComplete="new-password" />
                {meta.touched && meta.error && <div className="error" style={{ color: 'red' }}>{meta.error}</div>}
            </bootStrapForm.Group>
        );
    };

    const renderPasswordField = ({ field, form, meta, checkHidden }, label) => {
        return (
            <bootStrapForm.Group>
                <bootStrapForm.Label>{label}</bootStrapForm.Label>
                <bootStrapForm.Control isInvalid={meta.touched && meta.error} {...field} type="password" placeholder={label} autoComplete="new-password" />
                {meta.touched && meta.error && <div className="error" style={{ color: 'red' }}>{meta.error}</div>}
            </bootStrapForm.Group>
        );
    };

    return (
        <Formik
            validationSchema={schema}
            // validate={values => validate(values)}
            onSubmit={async (values, { setErrors }) => {
                //checking if the email is used
                const response = await CyberSecurity.post('/users/checkEmail', { email: values.email });
                if (response.data.message === 'Email is Taken') return setErrors({ email: 'There is already an account associated with this email' });

                //checking if the passwords not match
                if (values.password.localeCompare(values.rePassword) !== 0) return setErrors({ rePassword: 'Passwords not Match' });

                //every thing went well
                props.onFormSubmit(values);
            }}
            initialValues={{
                activated: true,
                firstName: '',
                lastName: '',
                email: '',
                companyName: '',
                password: '',
                rePassword: '',
            }}
        >
            {({
                handleSubmit,
                handleChange,
                handleBlur,
                values,
                touched,
                isValid,
                errors,
                validateField,
                isSubmitting
            }) => (
                <Form autoComplete="off">
                    <div className="grid px-4">
                        <div className="row">
                            <div className="col-md-12">
                                <Field name="firstName">
                                    {({ field, form, meta }) => renderTextField({ field, form, meta }, 'First Name')}
                                </Field>
                            </div>

                            <div className="col-md-12">
                                <Field name="lastName">
                                    {({ field, form, meta }) => renderTextField({ field, form, meta }, 'Last Name')}
                                </Field>
                            </div>

                            <div className="col-md-12">
                                <Field name="email">
                                    {({ field, form, meta }) => renderTextField({ field, form, meta }, 'Email')}
                                </Field>
                            </div>

                            <div className="col-md-12">
                                <Field name="companyName">
                                    {({ field, form, meta }) => renderTextField({ field, form, meta }, 'Company Name')}
                                </Field>
                            </div>

                            <div className="col-md-12">
                                <Field name="password">
                                    {({ field, form, meta }) => renderPasswordField({ field, form, meta }, 'Password')}
                                </Field>
                            </div>

                            <div className="col-md-12">
                                <Field name="rePassword">
                                    {({ field, form, meta }) => renderPasswordField({ field, form, meta }, 'Re-Type Password')}
                                </Field>
                            </div>

                        </div>


                        <div className="d-flex justify-content-center my-4">
                            <Button disabled={isSubmitting} type="submit" size="lg">
                                Access Dashboard
                                {submitting ? <Spinner className="ml-3" as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : null}
                            </Button>
                        </div>
                        <h3 className={`mt-3 ${updated && isValid ? null : 'd-none'}`} style={{ color: 'green' }} >Profile Updated</h3>
                        {/* <h3 className={`mt-3 ${isValid ? 'd-none' : null}`} style={{ color: 'red' }} >Please fill in the required fields</h3> */}
                    </div>
                </Form>
            )}
        </Formik>
    );
}

const mapStateToProps = (state) => {
    return {
        currentUser: state.currentUser,
        accessToken: state.accessToken
    };
};

export default connect(mapStateToProps)(PrivateBetaForm);
